import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { readySolutions } from '../data/readySolutions';
import Header from './Header';
import Footer from './Footer';

export default function DocDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const item = readySolutions.find(x => x.id === id);

  if (!item) {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="max-w-3xl mx-auto p-6">
          <h1 className="text-2xl font-bold mb-4">Документ не найден</h1>
          {/* <button className="text-purple-600 hover:underline" onClick={() => navigate(-1)}>← Назад</button> */}
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-[#F5F6FB]">
      <Header />
      <main className="max-w-3xl mx-auto bg-white rounded-2xl shadow p-6 my-8">
        <div className="flex items-center gap-3 mb-4">
          <img src={item.image} alt="" className="w-10 h-10" />
          <h1 className="text-2xl font-bold">{t(item.titleKey)}</h1>
        </div>
        <p className="text-gray-600 mb-6">{t(item.descKey)}</p>

        {/* Полное описание/контент */}
        <article className="prose max-w-none">
          {t(item.detailsKey)}
          {/* при желании можно хранить HTML/JSX вместо ключа и его отрисовывать */}
        </article>

        {/* <div className="mt-8">
          <button className="text-purple-600 hover:underline" onClick={() => navigate(-1)}>← Назад</button>
        </div> */}
      </main>
      <Footer />
    </div>
  );
}
